/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Handles sign-in error messages by mapping error codes to user-friendly messages.</blockquote>
 * 
 * @example
 * ```typescript
 * handleSignInError('CredentialsSignin', toast);
 * ```
 */

/**
 * Maps sign-in error codes to user-friendly error messages.
 * 
 * @param error - The error code from the sign-in result
 * @param toast - Toast function to display the error notification
 */
export function handleSignInError(
  error: string,
  toast: (options: {
    title: string;
    description: string;
    variant: 'default' | 'destructive';
  }) => void
): void {
  let errorMessage = 'Invalid email or password'

  // Map common errors to user-friendly messages
  switch (error) {
    case 'CredentialsSignin':
      errorMessage = 'The email or password you entered is incorrect'
      break
    case 'EmailNotVerified':
      errorMessage = 'Please verify your email address before signing in'
      break
    case 'AccountDisabled':
      errorMessage = 'Your account has been disabled. Please contact support'
      break
    default:
      errorMessage = 'Unable to sign in. Please try again'
  }

  toast({
    title: "Authentication Failed",
    description: errorMessage,
    variant: "destructive",
  })
}
